export const formatToUtcDate = (date: Date) => {
    const utcMillisCurrentDate = date.getTime();
    return new Date(utcMillisCurrentDate);
}